import React from 'react';
import { DialogManager } from '../../dialogs_new/DialogManager';
import useDialogLauncher from '../../../hooks/@lore/dialogs-routable/_hooks/useDialogLauncher';
import User from './User';
import { useConnect } from '@lore/query-connect';
import _ from 'lodash';
import mapResponse from '../../utils/mapResponse';
import { getDistanceFromLatLonInMiles } from '../../components/User/utils';
import { PayloadStates } from '@lore/utils';

export default function EventUser(props) {
  const {
    event,
    user,
    children
  } = props;

  const launch = useDialogLauncher();

  const invitations = useConnect('invitation.find', {
    where: {
      eager: {
        $where: {
          eventId: event.id
        }
      }
    },
    pagination: {
      pageSize: 1000
    }
  });

  const site = useConnect('site.byId', {
    id: event.data.siteId
  });

  const invitation = _.find(invitations.data, function(invitation) {
    return invitation.data.userId === user.id;
  });

  const selected = !!invitation;

  function onClick() {
    launch(DialogManager.UserView.Config(user.id, {
      modelName: 'event',
      modelId: event.id
    }));
  }

  const distance = getDistanceFromLatLonInMiles(site.data, user.data);
  const distanceText = distance > 1 ?
    `${distance.toLocaleString()} miles` :
    `1 mile`;

  return (
    <User
      user={user}
      selected={selected}
      footer={invitation ? mapResponse(invitation.data.response) : undefined}
      distance={site.state === PayloadStates.FETCHING ? '...' : distanceText}
      children={children}
      onClick={onClick}
    />
  );
}
